// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-bar {
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  width: 300px;
  height: 40px;
  padding: 0 12px;
  gap: 8px;
  border: 1px solid var(--border-input);
  border-radius: 4px;
  background: var(--surface-primary);
  position: relative;
  transition: border-color 0.15s;
}

.search-bar:focus-within {
  border-color: var(--color-brand);
}

.search-bar-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.search-bar:focus-within .search-bar-icon,
.search-bar:has(input:not(:placeholder-shown)) .search-bar-icon {
  display: none;
}

.search-bar-icon path {
  fill: var(--text-label);
}

.search-bar-input-wrapper {
  display: flex;
  box-sizing: border-box;
  align-items: center;
  flex: 1;
  min-width: 0;
}

.search-bar .input-box {
  position: static;
}

`, "",{"version":3,"sources":["webpack://./src/Widgets/AdvanceChartWidget/components/SearchBar.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,QAAQ;EACR,qCAAqC;EACrC,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,OAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".search-bar {\n  display: inline-flex;\n  align-items: center;\n  box-sizing: border-box;\n  width: 300px;\n  height: 40px;\n  padding: 0 12px;\n  gap: 8px;\n  border: 1px solid var(--border-input);\n  border-radius: 4px;\n  background: var(--surface-primary);\n  position: relative;\n  transition: border-color 0.15s;\n}\n\n.search-bar:focus-within {\n  border-color: var(--color-brand);\n}\n\n.search-bar-icon {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.search-bar:focus-within .search-bar-icon,\n.search-bar:has(input:not(:placeholder-shown)) .search-bar-icon {\n  display: none;\n}\n\n.search-bar-icon path {\n  fill: var(--text-label);\n}\n\n.search-bar-input-wrapper {\n  display: flex;\n  box-sizing: border-box;\n  align-items: center;\n  flex: 1;\n  min-width: 0;\n}\n\n.search-bar .input-box {\n  position: static;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
